module.exports = __webpack_public_path__ + "bh.svg?6d94e1984f74d9c9d3470e01080d5506";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/4x3/bh.svg
// module id = 1005
// module chunks = 27